import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import WalletList from './TransferList';

const Wallet = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Listado de transferencias' pageTitle='Transferencias' />
                <WalletList />
            </div>
        </React.Fragment>
    )
}

export default Wallet;